/* eslint-disable import/no-anonymous-default-export */
export default {
    API_ENDPOINT:'https://guarded-fjord-58725.herokuapp.com/api',
    TOKEN_KEY: 'harvest-table-client-auth-token',
    USER_NAME: 'harvest-table-user-name',
    USER_ID: 'harvest-table-user-id',
    NODE_ENV: process.env.NODE_ENV || 'development',
}
